document.addEventListener('DOMContentLoaded', function () {
  // Run on any variant radio change
  $(document).on('change', '.product input[type="radio"][name^="option-"]', function () {
    const $product = $(this).closest('.product');
    const $form = $product.find('.product_form, .shopify-product-form').first();

    // Product JSON is usually on the form via data-product (Turbo uses this in sections.js)
    let productData = $form.data('product');

    // Fallback: if it's not on the form, try a ProductJson script inside this product block
    if (!productData || !productData.variants) {
      const jsonEl = $product.find('script[type="application/json"][id*="ProductJson"]').first();
      if (jsonEl.length) {
        try { productData = JSON.parse(jsonEl.html()); } catch (e) {}
      }
    }

    if (!productData || !productData.variants) {
      console.warn('Product data not found on form or ProductJson script.');
      return;
    }

    // Build selected options in order (option-0, option-1, option-2)
    const selectedOptions = [];
    const optionCount = productData.options ? productData.options.length : 0;
    for (let i = 0; i < optionCount; i++) {
      const $checked = $product.find(`input[type="radio"][name="option-${i}"]:checked`);
      selectedOptions[i] = ($checked.val() || '').trim();
    }

    // Find a matching variant
    const variant = productData.variants.find(v =>
      v.options.every((opt, idx) =>
        (opt || '').trim().toLowerCase() === (selectedOptions[idx] || '').trim().toLowerCase()
      )
    );

    const $addToCart   = $('.add_to_cart', $product);
    const $paymentBtn  = $('.shopify-payment-button', $product);
    const $buttonsWrap = $product.find('.purchase-details__buttons');
    const addLabel     = $addToCart.data('label') || 'Add to Cart';

    if (variant && variant.available) {
      // ✅ valid & in stock → flip back to Add to Cart
      $addToCart.removeClass('disabled').removeAttr('disabled')
                .find('span').text(addLabel);
      $paymentBtn.removeClass('disabled');
      $buttonsWrap.removeClass('product-is-unavailable');
      $('.sold_out, .sold-out', $product).text('');
    } else {
      // ❌ invalid combo OR out of stock
      const message = variant ? 'Sold Out' : 'Unavailable';
      $addToCart.addClass('disabled').attr('disabled', 'disabled')
                .find('span').text(message);
      $paymentBtn.addClass('disabled');
      $buttonsWrap.addClass('product-is-unavailable');
      $('.sold_out, .sold-out', $product).text(message);
    }
  });

  // Optional: run once on load to normalize initial state
  $('.product input[type="radio"][name^="option-"]:checked').first().trigger('change');
});
